<div class="pill-container">
  <app-pill
    *ngFor="let pill of pillItems$ | async"
    [pillItem]="pill"
    [padding]="pillPadding"
    (clicked)="onPillClick(pill)" />
</div>
